import { render, staticRenderFns } from "./CarouseCard.vue?vue&type=template&id=7a480728&scoped=true"
import script from "./CarouseCard.vue?vue&type=script&lang=js"
export * from "./CarouseCard.vue?vue&type=script&lang=js"
import style0 from "./CarouseCard.vue?vue&type=style&index=0&id=7a480728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a480728",
  null
  
)

export default component.exports